import axios from "axios";
import { baseUrl } from "../config/constants";

export const serviceCall = {
  forgotPassword
};

async function forgotPassword(data) {
  try {
    const response = await axios.post(baseUrl + '/auth/forgotPassword', data);
    return response.data;
  } catch (error) {
    return error;
  }
}
